import { render, staticRenderFns } from "./BrandStoreList.vue?vue&type=template&id=80ae921e&lang=pug&"
import script from "./BrandStoreList.vue?vue&type=script&lang=js&"
export * from "./BrandStoreList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports